import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var groupComponentData = function groupComponentData(componentsData) {
  var groupedData = [];
  componentsData.reduce(function (previousComponent, currentComponent) {
    var _context;
    var name = _concatInstanceProperty(_context = "".concat(currentComponent.benefitName, " (")).call(_context, currentComponent.caseReference, ")");
    var groupedComponent = previousComponent;
    if (!groupedComponent[name]) {
      groupedComponent[name] = {
        benefit_id: currentComponent.caseId,
        benefitName: currentComponent.benefitName,
        benefitReference: currentComponent.caseReference,
        amount: 0,
        componentPayments: [],
        deductions: []
      };
      groupedData.push(groupedComponent[name]);
    }
    var creditAmount = Number(currentComponent.creditAmount);
    var debitAmount = Number(currentComponent.debitAmount) < 0 ? Number(currentComponent.debitAmount) : Number(currentComponent.debitAmount) * -1;
    groupedComponent[name].amount += creditAmount + debitAmount;

    // Adding payment to groupedComponent creditAmount list
    if (Number(currentComponent.creditAmount) > 0) {
      var _context2, _context3;
      groupedComponent[name].componentPayments.push({
        key: _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(name, "-")).call(_context3, currentComponent.entitlement.value, "-")).call(_context2, currentComponent.coverStartDate),
        amount: Number(currentComponent.creditAmount),
        componentName: currentComponent.entitlement.description,
        coverStartDate: currentComponent.coverStartDate,
        coverEndDate: currentComponent.coverEndDate,
        type: currentComponent.entitlement
      });
    }

    // Adding deduction to groupedComponent debitAmountList list
    if (Number(currentComponent.debitAmount) !== 0) {
      var _context4;
      groupedComponent[name].deductions.push({
        key: _concatInstanceProperty(_context4 = "".concat(name, "-")).call(_context4, currentComponent.coverStartDate),
        amount: Number(currentComponent.debitAmount),
        description: currentComponent.entitlement.description,
        name: {
          description: currentComponent.deductionName
        }
      });
    }
    return groupedComponent;
  }, []);
  return groupedData;
};
export default groupComponentData;